<template>
  <div class="imgBox">
    <img :src="info.img" alt="">
    <div class="name-box">
      <div class="top">{{info.name}}</div>
      <div class="bottom">{{info.eng}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImgBox",
  props: {
    info: Object
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.imgBox {
  width: 100%;
  height: 536px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;

  >img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  >.name-box {
    position: relative;
    z-index: 99;
    >.top {
      font-size: 42px;
      color: #FFFFFF;
      font-family: 'SOURCEHANSANSCN';
      text-align: center;
    }

    >.bottom {
      font-size: 22px;
      color: #E7CE8D;
      font-family: 'SOURCEHANSANSCN';
      margin-top: 8px;
      text-align: center;
    }
  }
}
</style>
